<template>
  <Modal :visible="visible" title="合规提示" width="600px" :maskClosable="false" :footer="null" destroyOnClose :zIndex="3000" @cancel="handleCancel">
    <section class="risk-container">
      <template v-for="(risk, rIndex) in riskDatas" :key="rIndex">
        <div class="risk-box" >
          <section class="risk-header">
            <component :is="risk.icon" :style="{ 'color': `${risk.color}` }" class="risk-item-icon"></component>
            <span :style="{ 'color': `${risk.color}`, 'background-color' : `${risk.bgColor}` }" class="risk-item-name">{{ risk.name }}</span>
          </section>
          <section class="risk-content">
            <template v-for="(rd, dIndex) in risk.rules" :key="dIndex">
              <section class="risk-item-msg" v-html="deleteHtmlTag(rd.ruleMsg)"></section>
            </template>
          </section>
        </div>
      </template>
    </section>
    <section class="risk-footer">
      <Button v-if="isCancelBtn" @click="handleCancel">取消</Button>
      <Button class="btn-confirm" type="primary" @click="handleOk">确认</Button>
    </section>
  </Modal>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { Modal, Button } from 'ant-design-vue';
import { ExclamationCircleFilled, WarningFilled, InfoCircleFilled } from '@ant-design/icons-vue';

const visible = ref(true)

const props = defineProps({
  isCancelBtn: {
    type: Boolean,
    default: false
  },
  onOk: {
    type: Function,
    default: () => () => {}
  },
  onCancel: {
    type: Function,
    default: () => () => {}
  },
  ruleDatas: {
    type: Array as any,
    required: true,
    default: () => []
  }
})

// 处理第一个空标签无法删除的问题
const deleteHtmlTag = (string)=>{
  if(string === null) return ''

  let reg =/<[^>]+>/g;

  return string.replace(reg, '').replace(/&nbsp;/ig, '');
}

const riskLevel = [
  { name: '高风险', level: 'high', icon: ExclamationCircleFilled, color: '#dc2626', bgColor: 'rgba(220, 38, 38, 0.1)' }, 
  { name: '中风险', level: 'middle', icon: WarningFilled, color: '#f5990b', bgColor: 'rgba(245, 153, 11, 0.1)' }, 
  { name: '低风险', level: 'low', icon: InfoCircleFilled, color: '#2c68ff', bgColor: 'rgba(37, 99, 235, 0.1)' }
]

const riskDatas = computed(() => {
  let datas = []
  riskLevel.forEach(risk => {
    const rules = props.ruleDatas.filter(item => item.riskLevel === risk.level)
    if(rules.length == 0)  return

    const d = {...risk, rules}
    datas.push(d)
  })

  return datas
})

const handleCancel = () => { 
  if(props.onCancel && typeof props.onCancel === 'function') {
    props.onCancel()
  }

  visible.value = false
}

const handleOk = () => { 
  if(props.onOk && typeof props.onOk === 'function') {
    props.onOk()
  }

  visible.value = false
} 
</script>
<style scoped>
.risk-container{
  padding: 20px;
}
.risk-header{
  display: flex;
  align-items: center;
}
.risk-item-icon{
  font-size: 18px;
}
.risk-item-name{
  padding: 2px 10px;
  border-radius: 4px;
  margin-left: 12px;
}
.risk-item-msg{
  padding: 10px 28px;
}
.risk-footer{
  text-align: end;
  padding: 0 20px 20px 0;
}
.btn-confirm{
  margin-left: 10px;
}
</style>